<p>productvariant-columnchart works!</p>
